import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { LineCrossingsOverlay } from "../Sites/SiteAboutPage/LineCrossingsOverlay";
import type { LineCrossing } from "../EditCamera/editCameraStore/editCameraStore";

const PREVIEW_WIDTH = 283;
const PREVIEW_HEIGHT = 187;

export const ActiveLineCrossingsWindow = ({
  selectedAlertCameraInfo,
  lineCrossingsSelectedAlert,
  loadingLineCrossingsInfo,
}: {
  selectedAlertCameraInfo: any;
  lineCrossingsSelectedAlert: LineCrossing[];
  loadingLineCrossingsInfo: boolean;
}) => {
  return (
    <div className="h-[260px] w-[350px] max-h-[260px] max-w-[350px] overflow-hidden box-border">
      {loadingLineCrossingsInfo && (
        <div className="flex flex-col items-center justify-center h-[187px] w-[283px] max-w-[283px] gap-3 shrink-0">
          <CircularProgress size={24} />
          <p className="font-mulish text-[12px]">Fetching Line Crossings</p>
        </div>
      )}
      {!loadingLineCrossingsInfo &&
        selectedAlertCameraInfo.preview_url &&
        lineCrossingsSelectedAlert && (
          <div className="relative shrink-0">
            <img
              className="w-[283px] h-[187px] block"
              src={selectedAlertCameraInfo.preview_url}
              alt="Camera preview"
            />
            {lineCrossingsSelectedAlert.length > 0 && (
              <div
                className="absolute top-0 left-0"
                style={{ width: 283, height: 187 }}
              >
                <LineCrossingsOverlay
                  lines={lineCrossingsSelectedAlert}
                  width={PREVIEW_WIDTH}
                  height={PREVIEW_HEIGHT}
                />
              </div>
            )}
          </div>
        )}
      {!loadingLineCrossingsInfo &&
        selectedAlertCameraInfo.preview_url &&
        lineCrossingsSelectedAlert &&
        lineCrossingsSelectedAlert.length > 0 && (
          <div className="absolute top-[220px] w-[283px] h-[57px] overflow-auto">
            <div className="absolute left-0 top-0 min-h-[57px] w-[283px]">
              {lineCrossingsSelectedAlert.map((line, index) => (
                <div
                  key={line.id ?? index}
                  className="flex items-center gap-2 py-0.5"
                >
                  <div
                    style={{
                      height: 10,
                      width: 6,
                      background: line.color,
                    }}
                    className="shrink-0"
                  />
                  <p className="font-mulish text-[10px]">
                    Line crossing {index + 1}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      {!loadingLineCrossingsInfo &&
        selectedAlertCameraInfo.preview_url &&
        lineCrossingsSelectedAlert &&
        lineCrossingsSelectedAlert.length === 0 && (
          <div className="absolute top-[220px] w-[283px]">
            <p className="font-mulish text-[10px]">
              No line crossings configured
            </p>
          </div>
        )}
      {!loadingLineCrossingsInfo && !selectedAlertCameraInfo.preview_url && (
        <div>
          <p className="font-mulish text-[12px]">
            Unable to Display Line Crossings
          </p>
        </div>
      )}
    </div>
  );
};
